import { isBrowser } from '../isBrowser';
import getDataLayer from './getDataLayer';
import { getOwnCategory } from '../getOwnCategory';
import { DL_CURRENCY, DlEventSource } from './constant';
import { ICartItem } from '../../typings/ICartItem';

export const DL_helper = (
  cartItem: ICartItem,
  name: string,
  count: number,
  dlEventSource: DlEventSource,
  dlItemIndex?: number,
) => {
  if (isBrowser) {
    const product = cartItem?.product;
    const customCategory = getOwnCategory(product?.customCategories);
    const cartItemPrice = cartItem?.price ? Number((Number(cartItem.price) / cartItem.count).toFixed(2)) : 0;
    getDataLayer().push({
      event: name,
      ecommerce: {
        currency: DL_CURRENCY,
        value: (cartItemPrice * count).toFixed(2),
        items: [
          {
            item_name: product?.title,
            item_id: product?.id,
            item_list_id: dlEventSource.id,
            item_list_name: dlEventSource.name,
            item_category: customCategory?.name,
            item_brand: product?.brand?.nameDe,
            index: dlItemIndex,
            quantity: count,
            price: cartItemPrice,
          },
        ],
      },
    });
  }
};
